BaseModel = require './base_model.coffee'

class global.FlowAction extends BaseModel
  @ATTRIBUTES = {
    id: {}
    is_first: { default: false }
    name: {}
    template_id: {}
    delay_after_previous_step_amount: { type: Number }
    delay_after_previous_step_unit: { }
    recipients_statistics: { type: Object }
    send_immediately: false
    send_at: { type: Date }
    send_at_in_user_time_zone: { type: Date }
    immediately: {}
    step: { type: Number }
    type: {}
    manual_task_parameters: {}
    signature: {}
    send_as_reply: {}
    undefined_time: {}
    _destroy: {}
    template_copied_from_id: {}
    original_template_id: {}
  }

  @SERIALIZABLE_ATTRIBUTES = [
    'id', 'step', 'template_id', 'delay_after_previous_step_amount', 'delay_after_previous_step_unit',
    'send_at', 'type', 'manual_task_parameters', 'send_as_reply', 'undefined_time', 'send_immediately',
    '_destroy', 'template_copied_from_id'
  ]

  @ASSOCIATIONS = {
    email_statistic: -> EmailStatistic
    template: -> Template
    flow: -> Flow
    contact_specific_templates: -> ContactSpecificTemplate
  }

  @SERIALIZABLE_ASSOCIATIONS = ['contact_specific_templates']

  serialize: (selected_attributes = false) ->
    serialized = super selected_attributes

    if @template.id == -1
      serialized.original_template_attributes = Object.assign({}, @template)
      serialized.original_template_attributes.id = null

    serialized

  isEmailFlowAction: ->
    @type == 'EmailFlowAction' || @manual_task_parameters.service == 'ManualTasksServices::Email'

  afterInitialize: ->
    @human_step = @step + 1
    @is_first = @step == 0

  humanSendAt: ->
    return null unless @send_at and @send_at.isValid and @send_at.isValid()
    @send_at.clone().subtract(@send_at.utcOffset(), 'minutes').format 'HH:mm'

  humanDelay: ->
    return if !@delay_after_previous_step_unit
    "#{@delay_after_previous_step_amount} #{@humanUnit()}"

  humanUnit: ->
    if @delay_after_previous_step_unit == 'months'
      if @delay_after_previous_step_amount == 1 then 'mês' else 'meses'

    else if @delay_after_previous_step_unit == 'weeks'
      if @delay_after_previous_step_amount == 1 then 'semana' else 'semanas'

    else if @delay_after_previous_step_unit == 'days'
      if @delay_after_previous_step_amount == 1 then 'dia' else 'dias'



// WEBPACK FOOTER //
// ./src/models/flow_action.coffee